import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import GButton from "components/ui/button/Button";
import { Box, Flex, Stack, useToast, Checkbox } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  allBranchesInDiscount,
  createDiscountBranches,
  getDiscountsBranches,
  getTagsInBranches,
} from "../../services/discountsBranchesService";

const AppliesOnBranchesModal = ({ onClose }) => {
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { handleSubmit, setValue, register } = useForm();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });

  const toast2 = useToast({
    position: "top",
    duration: 3000,
    status: "error",
  });

  const branches = useSelector((state) => state.discountsBranches);

  useEffect(() => {
    dispatch(getTagsInBranches(id.id));
  }, [dispatch, id.id]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.discounts.applies_on_branches")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.Branches = values.Branches?.map((el) => ({
                BranchId: el.BranchId,
              }));
              values.DisCountId = id.id;
              values.UserId = localStorage.getItem("userId");
              if (
                (values.Branches === undefined ||
                  values.Branches?.length === 0) &&
                values.IsAllBranches === false
              ) {
                toast2({
                  description: t("validation.required"),
                });
              } else {
                const actionToDispatch = values.IsAllBranches
                  ? dispatch(allBranchesInDiscount(id.id.toString()))
                  : dispatch(createDiscountBranches(values));
                actionToDispatch.unwrap().then((_) => {
                  toast({
                    description: t("pages.discounts.branch_discount_created"),
                  });
                  dispatch(getDiscountsBranches(id.id));
                  onClose();
                });
              }
            })}
          >
            <Stack spacing={6}>
              <Checkbox {...register("IsAllBranches")}>
                {t("pages.discounts.all_Branches")}
              </Checkbox>

              <MultiSelect
                title={t("pages.inventory.branches")}
                data={
                  Array.isArray(branches?.tagsInBranch)
                    ? branches?.tagsInBranch.map((el) => ({
                        ...el,
                        label: el.BranchName,
                        value: el.BranchId,
                      }))
                    : []
                }
                isMulti={true}
                isRequired={true}
                onChange={(e) => setValue("Branches", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("pages.inventory_item_details.apply")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={branches.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={branches.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default AppliesOnBranchesModal;
